
import s0 from '~/.nuxt/gb-cms/sections/BanquetsSection'
import s1 from '~/.nuxt/gb-cms/sections/HistorySection'
import s2 from '~/.nuxt/gb-cms/sections/VideoSection'
import s3 from '~/.nuxt/gb-cms/sections/ContactForm'
import s4 from '~/.nuxt/gb-cms/sections/MapSection'
import s5 from '~/.nuxt/gb-cms/sections/GallerySection'
import s6 from '~/.nuxt/gb-cms/sections/GallerySliderSection'
import s7 from '~/.nuxt/gb-cms/sections/BgImageText'
import s8 from '~/.nuxt/gb-cms/sections/ImageText'
import s9 from '~/.nuxt/gb-cms/sections/HeroSection'
import s10 from '~/.nuxt/gb-cms/sections/HomeInfo'
import s11 from '~/.nuxt/gb-cms/sections/OfferSection'
import s12 from '~/.nuxt/gb-cms/sections/VoucherSection'
import s13 from '~/.nuxt/gb-cms/sections/MenuSection'
import s14 from '~/.nuxt/gb-cms/sections/PrivacyPolicy'
import s15 from '~/.nuxt/gb-cms/sections/MenuList'

const sectionMapper = {
	'banquets-section': s0,
	'history-section': s1,
	'video-section': s2,
	'contact-form': s3,
	'map-section': s4,
	'gallery-section': s5,
	'gallery-slider-section': s6,
	'bg-image-text': s7,
	'image-text': s8,
	'hero-section': s9,
	'home-info': s10,
	'offer-section': s11,
	'voucher-section': s12,
	'menu-section': s13,
	'privacy-policy': s14,
	'menu-list': s15
}

export default sectionMapper
